import { Phone } from "lucide-react";
import { PHONE_HREF } from "@/components/Header";

const StickyCallButton = () => (
  <a
    href={PHONE_HREF}
    className="fixed bottom-4 right-4 z-50 md:hidden bg-[#1a1a1a] text-[#FFC300] p-4 rounded-full shadow-lg hover:opacity-90 transition-opacity"
    aria-label="Call Now"
  >
    <Phone className="w-6 h-6" />
  </a>
);

export default StickyCallButton;
